import React from 'react';
import {
  Container,
  Box,
  Typography,
} from '@mui/material';
import { CreditCard } from '@mui/icons-material';
import BillingSettings from '../components/BillingSettings';

export default function BillingSettingsPage() {
  return (
    <Container maxWidth="lg" sx={{ mt: { xs: 2, md: 4 }, mb: 4, px: { xs: 1.5, md: 3 } }}>
      <Box sx={{
        mb: { xs: 3, md: 4 },
        p: { xs: 2.5, md: 3 },
        borderRadius: 3,
        background: 'linear-gradient(135deg, rgba(0,128,96,0.08) 0%, rgba(0,76,63,0.04) 100%)',
        border: '1px solid rgba(0,128,96,0.12)',
      }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Box sx={{
            width: 52,
            height: 52,
            borderRadius: 2.5,
            background: 'linear-gradient(135deg, #008060 0%, #004c3f 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 4px 14px rgba(0, 128, 96, 0.35)',
            flexShrink: 0,
          }}>
            <CreditCard sx={{ color: '#fff', fontSize: 28 }} />
          </Box>
          <Box>
            <Typography variant="h5" sx={{ fontWeight: 800, color: '#1a1a1a', lineHeight: 1.2 }}>
              Συνδρομή
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Διαχείριση πλάνου, δοκιμαστικής περιόδου και χρεώσεων
            </Typography>
          </Box>
        </Box>
      </Box>

      <BillingSettings />
    </Container>
  );
}
